const React = require("react");
const ButtonBack = require("../../../../dumb/Button/BackB");
const Caption = require("../../../../dumb/Caption/C");
const {backLocation, pushLocation} = require("../../../../../router");

const FormApp = require('../FormApp');
const {apiV2AppUpdate, apiV2AppGet} = require("../../../../../api/merchant/application");
const {LINK_DEVELOPER_OPTIONS} = require("../../../../../constants/links");
const withState = require("../../../../../utils/withState");
import WrapperWithLoading from '../../../../dumb/WrapperWithLoading/B';

module.exports = withState((setState, self, onMount) => {

  self.state = {
    ...self.state,
    loading: true
  }

  onMount(() => {
    const appId = self.props.params.appId;

    if (!appId) {
      pushLocation({
        path: LINK_DEVELOPER_OPTIONS
      })
      return;
    }

    return apiV2AppGet({
      id: appId
    }).then((appData) => {
      setState({appData, loading: false});
    })
  })

  return (state, props) => {
    const appId = props.params.appId;
    let appData = {};

    if (!state.loading){
      const _appData = state.appData;

      const headers = (_appData.headers || []).map((el) => {
        const [name, value] = el;
        return {name, value};
      })

      appData = {
        name: _appData.name,
        callback_address: _appData.callback_address,
        critical_callbacks_address: _appData.critical_callbacks_address,
        headers
      };

      // appData.headers = _appData.headers.map((el) => {
      //   const [name, value] = el;
      //   return {name, value};
      // })
    }

    const request = async (data) => apiV2AppUpdate(data).then(backLocation);

    return (
      <div className="wmin270">
        <div className="layoutRow fhaS fvaC">
          <ButtonBack
            className="m-10 mr10"
            onClick={backLocation}
          />
          <Caption>Edit App</Caption>
        </div>
        <WrapperWithLoading
          loading={state.loading}
        >
          <div className="mt35 wmax900 w@m">
            {!state.loading && (
              <FormApp
                appId={appId}
                defaultData={appData}
                request={request}
                resultText={[
                  'App updated',
                  'You\'ve successfully updated data of your application.'
                ]}
              />
            )}
          </div>
        </WrapperWithLoading>
      </div>
    )
  };
}, {})
